// Mock data pour Phoenix Negoce
export const mockProducts = [
  {
    id: '1',
    name: 'Polo Premium Coton',
    category: 'textile',
    price: 45.99,
    description: 'Polo en coton premium, disponible en plusieurs couleurs',
    image: 'https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=800',
    featured: true
  },
  {
    id: '2',
    name: 'Sac en Cuir Véritable',
    category: 'maroquinerie',
    price: 189.99,
    description: 'Sac à main en cuir véritable, fait main',
    image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=800',
    featured: true
  },
  {
    id: '3',
    name: 'Pellets de Bois Premium',
    category: 'pellets',
    price: 5.50,
    description: 'Sac de 15kg, taux d\'humidité < 8%',
    image: 'https://images.unsplash.com/photo-1516464316143-5b1e9f6b3f5c?w=800',
    featured: true
  },
  {
    id: '4',
    name: 'Chemise Business',
    category: 'textile',
    price: 59.99,
    description: 'Chemise élégante pour homme, coupe ajustée',
    image: 'https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=800',
    featured: false
  },
  {
    id: '5',
    name: 'Portefeuille Cuir',
    category: 'maroquinerie',
    price: 79.99,
    description: 'Portefeuille compact en cuir italien',
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?w=800',
    featured: false
  },
  {
    id: '6',
    name: 'Pull Laine Mérinos',
    category: 'textile',
    price: 89.99,
    description: 'Pull en laine mérinos de haute qualité',
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800',
    featured: true
  },
  {
    id: '7',
    name: 'Ceinture en Cuir',
    category: 'maroquinerie',
    price: 49.99,
    description: 'Ceinture élégante en cuir véritable',
    image: 'https://images.unsplash.com/photo-1624222247344-550fb60583f0?w=800',
    featured: false
  },
  {
    id: '8',
    name: 'Pellets Bois Dur',
    category: 'pellets',
    price: 6.20,
    description: 'Palette complète disponible, livraison possible',
    image: 'https://images.unsplash.com/photo-1545259742-25a6d9e4d1c7?w=800',
    featured: false
  }
];

export const categories = [
  { id: 'all', name: 'Tous les produits' },
  { id: 'textile', name: 'Textile' },
  { id: 'maroquinerie', name: 'Maroquinerie' },
  { id: 'bagagerie', name: 'Bagagerie' },
  { id: 'bricolage', name: 'Bricolage' },
  { id: 'combustible', name: 'Combustible' },
  { id: 'alimentaire', name: 'Alimentaire' },
  { id: 'maison-equipement', name: 'Maison & Équipement' },
  { id: 'jardin-exterieur', name: 'Jardin & Extérieur' },
  { id: 'automobile', name: 'Automobile' },
  { id: 'divers', name: 'Divers' }
];

export const services = [
  {
    id: '1',
    title: 'Textile de Qualité',
    description: 'Large gamme de vêtements et textiles de haute qualité pour professionnels et particuliers',
    icon: 'Shirt'
  },
  {
    id: '2',
    title: 'Maroquinerie Artisanale',
    description: 'Articles en cuir véritable, fabriqués avec soin et attention aux détails',
    icon: 'Briefcase'
  },
  {
    id: '3',
    title: 'Pellets de Bois',
    description: 'Combustible écologique de première qualité, livraison disponible',
    icon: 'Flame'
  },
  {
    id: '4',
    title: 'Livraison Rapide',
    description: 'Service de livraison fiable et rapide pour tous vos produits',
    icon: 'Truck'
  }
];